import "../../utilities/utilities_namespace.js";

window.Sparkle ??= {};
window.Sparkle.Utilities ??= {};

window.Sparkle.Utilities.Scrolling = {
  freeze: function freeze() {
    var x = jQuery(window).scrollLeft();
    var y = jQuery(window).scrollTop();

    jQuery(window).on("scroll.freeze", function () {
      window.scrollTo(x, y);
    });
  },
  unfreeze: function unfreeze() {
    jQuery(window).off(".freeze");
  },
};
